import { Checkbox } from '@sakura-grp/ui/checkbox';
import { Label } from '@sakura-grp/ui/label';

export interface StoreFilterItem {
  id: string;
  shortName: string;
}

interface StoreFilterProps {
  stores: StoreFilterItem[];
  selectedStores: string[];
  onToggle: (shortName: string) => void;
}

export function StoreFilter({ stores, selectedStores, onToggle }: StoreFilterProps) {
  if (stores.length === 0) return null;

  return (
    <div
      className="!divide-(--border) grid flex-none grow items-center divide-x rounded-lg border bg-white text-xs font-bold"
      style={{ gridTemplateColumns: `repeat(${stores.length}, minmax(0, 1fr))` }}
    >
      {stores.map((store) => (
        <div key={store.id} className="gap-xs flex items-center justify-center">
          <Checkbox
            id={`store-${store.id}`}
            checked={selectedStores.includes(store.shortName)}
            onCheckedChange={() => onToggle(store.shortName)}
            className="size-(--bigger-sm)"
          />
          <Label
            htmlFor={`store-${store.id}`}
            className="h-xl gap-md flex cursor-pointer select-none items-center text-sm font-bold leading-none tracking-tight"
          >
            {store.shortName}
          </Label>
        </div>
      ))}
    </div>
  );
}
